<script setup lang="ts">
/* __placeholder__ */
import type { PostsOrPages } from '@tryghost/content-api';

const { pending, data: posts } = await useLazyFetch<PostsOrPages>('/api/glossary', {
  params: {
    limit: 5,
    filter: 'tag:glossary',
  },
});
</script>

<template>
  <div class="max-h-[480px] overflow-scroll">
    <div v-if="pending" class="flex flex-col divide-y-[1px]">
      <div v-for="i in 5" :key="i" class="py-3">
        <div class="flex h-[84px] flex-row justify-between gap-x-2 md:max-lg:flex-col">
          <div class="w-full">
            <SkeletonLoader type="rectangle" bg-class="bg-gray-200" class="mb-2 h-[56px] w-full" />
            <SkeletonLoader type="rectangle" bg-class="bg-gray-200" class="mb-2 h-[20px] w-full" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col divide-y-[1px]">
      <div v-for="post in posts" :key="post.id" class="py-3">
        <GlossaryListItem :post="post" />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
